var React = require('react');

function Percent (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"19","y1":"5","x2":"5","y2":"19","key":0}),React.createElement("circle",{"cx":"6.5","cy":"6.5","r":"2.5","key":1}),React.createElement("circle",{"cx":"17.5","cy":"17.5","r":"2.5","key":2})]);
}

Percent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-percent"};

module.exports = Percent;

Percent.default = Percent;
